import React from 'react';
import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import ToggleableSection from '../common/ToggleableSection.jsx';
import SelectSetting from '../common/SelectSetting.jsx';
import SliderSetting from '../common/SliderSetting.jsx';
import SettingsSection from '../common/SettingsSection.jsx';

function GridViewSettings({ widgetId }) {
  const settings = useSelector(s => s.dashboard.widgets[widgetId].settings) || {};
  const setWidgetAttribute = useSetWidgetAttribute(widgetId);

  const setAttribute = (p, v) => {
    setWidgetAttribute(`settings.${p}`, v);
  }
  const props = {
    prefix: 'gridView',
    selectedObject: settings,
    setAttribute: setAttribute,
    hideDescription: true
  }
  
  return (
    <>
      <hr />
      <ToggleableSection title={I18n.t('grid_view')} {...props}>
        <SettingsSection>
          <SelectSetting {...props} defaultValue='toggleable' label={I18n.t('position')} attr='position' options={[
            {label: I18n.t('toggleable'), value: 'toggleable'},
            {label: I18n.t('right'), value: 'right'}, {label: I18n.t('left'), value: 'left'},
            {label: I18n.t('below'), value: 'below'}, {label: I18n.t('above'), value: 'above'}
          ]} />
          <SliderSetting {...props} label={I18n.t('size')} min={10} max={90} defaultValue={50} attr='size' unit='%' />
          <p className='description'>{I18n.t('grid_size_setting_info')}</p>
        </SettingsSection>
      </ToggleableSection>
    </>
  )
}

export default GridViewSettings;